<div class="partners-logos">
    @for (logo of partnerLogos(); track logo.src) {
        <img [ngStyle]="{'max-width': 100 / partnerLogos().length - 5 + '%'}"
             [src]="'assets/' + brand + '/images/logos/' + logo.src"
             [alt]="logo.alt"
             [class]="'partner-logo ' + logo.class"/>
    }
</div>